import { useCallback } from 'react'
import {
	ApiGetWithToken,
	useApiFetch
} from 'shared/api'
import {
	lvApiBy,
	searchApiBy
} from 'interface/endpoints'
import {
	LvHaisinCountResult,
	LvHaisinListResult,
	LvLogResultList,
	LvProjectResult,
	LvProjectResultList
} from './types'

export * from './types'

// 1日単位でのcacheTime
const t = Math.floor(new Date().getTime() / 86400000)

const defaultRange = '1y'

export const useListLvProject = (
	has: boolean,
	searchId: number | undefined | null,
	range: string = defaultRange
) => useApiFetch(
	useCallback(
		(apiAccess, cancelToken) => {
			if (!has || !searchId) return null
      return ApiGetWithToken<LvProjectResultList>(
        apiAccess,
				searchApiBy(searchId, '/lv/project/list', { t, range }),
        cancelToken
      )
    },
		[searchId, has, range]
	)
)

export const useGetLvProject = (
	projectCode: string | undefined | null
) => useApiFetch(
	useCallback(
		(apiAccess, cancelToken) => {
			if (!projectCode) return null
      return ApiGetWithToken<LvProjectResult>(
        apiAccess,
				lvApiBy(projectCode, undefined, { t }),
        cancelToken
      )
    },
		[projectCode]
	)
)

export const useListLvLog = (
	projectCode: string | undefined | null
) => useApiFetch(
	useCallback(
		(apiAccess, cancelToken) => {
			if (!projectCode) return null
      return ApiGetWithToken<LvLogResultList>(
        apiAccess,
				lvApiBy(projectCode, '/logs', { t }),
        cancelToken
      )
    },
		[projectCode]
	)
)

export const useCountLvHaisin = (
	projectCode: string | undefined | null
) => useApiFetch(
	useCallback(
		(apiAccess, cancelToken) => {
			if (!projectCode) return null
      return ApiGetWithToken<LvHaisinCountResult>(
        apiAccess,
				lvApiBy(projectCode, '/haisin/count', { t }),
        cancelToken
      )
    },
		[projectCode]
	)
)

export const useListLvHaisin = (
	has: boolean,
	projectCode: string | undefined | null
) => useApiFetch(
	useCallback(
		(apiAccess, cancelToken) => {
			if (!projectCode || !has) return null
      return ApiGetWithToken<LvHaisinListResult>(
        apiAccess,
				lvApiBy(projectCode, '/haisin', { t }),
        cancelToken
      )
    },
		[projectCode, has]
	)
)
